export default {
  methods: {
    showToast(message, params = {}) {
      this.$bvToast.toast(message, {
        autoHideDelay: 3000,
        variant: 'danger',
        noCloseButton: true,
        solid: true,
        appendToast: true,
        ...params
      })
    }
  }
}
